import ChatUser from "./ChatUser";
import { IUserTypes } from "../../../types/contacts";

interface FavouritesProps {
  users: IUserTypes[];
  selectedChatId: number;
  onSelectChat: (id: number) => void;
}

const Favourites = ({ selectedChatId, users, onSelectChat }: FavouritesProps) => {
  // console.log('Favoritos', users)

  return (
    <>

      <div className="d-flex align-items-center px-4 mt-4 mb-2">
        <div className="flex-grow-1">
          <h4 className="mb-0 font-size-14 text-muted text-uppercase">
            Favoritos ({users.length})
          </h4>
        </div>
      </div>

      <ul className="list-unstyled chat-list">
        {users.map((user) => (
          <ChatUser
            key={user.id}
            user={user}
            selectedChat={selectedChatId}
            unreadCount={user.unreadCount}   // 👈 já vem do useChats!
            onSelectChat={onSelectChat}
          />
        ))}
      </ul>
    </>
  );
};

export default Favourites;